import {
  getSessionStorage,
  setSessionStorage,
  deleteFromSessionStorage,
} from 'config/appConfig'
import { action } from 'mobx'
import { checkoutContainer } from 'src/models'

// Shared by ShippingAddressComponents.jsx and ShippingAddressListWithForm.jsx
export const LEGAL_ADDRESS_SAME_AS_SHIPPING_KEY =
  'legalAddressSameAsShippingAddress'

export const DEFAULT_ADDRESS_FIELD_NAME = 'setDefaultAddress'

export const DEFAULT_ADDRESS_CONTROL_ID = 'address-save-as-default'
export const DEFAULT_ADDRESS_TEST_ID = 'qa-address-save-as-default'

export const isDefaultAddressCheckbox = (target = {}) =>
  target?.name === DEFAULT_ADDRESS_FIELD_NAME ||
  target?.id === DEFAULT_ADDRESS_CONTROL_ID ||
  target?.dataset?.testid === DEFAULT_ADDRESS_TEST_ID ||
  target?.getAttribute?.('data-testid') === DEFAULT_ADDRESS_TEST_ID

export const normalizeLegalAddressPreference = value => {
  if (value === true || value === 'true') return 'true'
  if (value === false || value === 'false') return 'false'
  return 'false'
}

export const hasLegalAddressPreference = value =>
  value === true || value === false || value === 'true' || value === 'false'

export const initializeLegalAddressPreference = () => {
  /** Once the shopper has explicitly answered, later remounts must not re-derive from storage and flip it back */
  if (checkoutContainer.isLegalAddressPreferenceSet) {
    return
  }
  const savedPreference = getSessionStorage(LEGAL_ADDRESS_SAME_AS_SHIPPING_KEY)
  const hasSavedPreference = hasLegalAddressPreference(savedPreference)
  /** Yes is the default answer until the shopper has an explicit saved preference */
  checkoutContainer.isLegalAddressSameAsShipping = hasSavedPreference
    ? normalizeLegalAddressPreference(savedPreference)
    : 'true'
  checkoutContainer.isLegalAddressPreferenceSet = hasSavedPreference
  /** A restored sessionStorage value only ever comes from a genuine radio answer (see handleLegalAddressRadioOption) */
  if (hasSavedPreference) {
    checkoutContainer.isLegalAddressRadioAnsweredByShopper = true
  }
}

/** Yes radio reflects the current value, including the Yes-by-default state */
export const isLegalAddressYesSelected = () =>
  normalizeLegalAddressPreference(
    checkoutContainer.isLegalAddressSameAsShipping
  ) === 'true'

/** No radio only shows selected once the shopper has explicitly answered No */
export const isLegalAddressNoSelected = () =>
  checkoutContainer.isLegalAddressPreferenceSet &&
  normalizeLegalAddressPreference(
    checkoutContainer.isLegalAddressSameAsShipping
  ) === 'false'

export const handleLegalAddressRadioOption = action(
  (selectedValue = 'false') => {
    const normalized = normalizeLegalAddressPreference(selectedValue)
    checkoutContainer.isLegalAddressSameAsShipping = normalized
    checkoutContainer.isLegalAddressPreferenceSet = true
    checkoutContainer.isLegalAddressRadioAnsweredByShopper = true
    setSessionStorage(LEGAL_ADDRESS_SAME_AS_SHIPPING_KEY, normalized)
  }
)

export const clearLegalAddressPreference = action(() => {
  deleteFromSessionStorage(LEGAL_ADDRESS_SAME_AS_SHIPPING_KEY)
  checkoutContainer.isLegalAddressSameAsShipping = 'false'
  checkoutContainer.isLegalAddressPreferenceSet = false
  checkoutContainer.isLegalAddressRadioAnsweredByShopper = false
})

export const applyDefaultAddressLegalPreference = action(isDefaultChecked => {
  /** Unanswered always defaults to Yes - unchecking must not force the radio to No */
  checkoutContainer.isLegalAddressSameAsShipping = 'true'
  checkoutContainer.isLegalAddressPreferenceSet = isDefaultChecked
})
